/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "fb4602f0cec368537f009343dfca9da28af2420c";
